import FlexBox from '@ess/ui/FlexBox';
import { Button } from '@ess/ui/Button';
import { useTranslation } from 'react-i18next';
import NumberInput from '@ess/ui/NumberInput';
import { useState } from 'react';
import Text from '@ess/ui/Text';

const LiveRoomConnectorPanel = () => {
  const { t } = useTranslation();

  const [testNumber, setTestNumber] = useState<string>('');

  const onClear = () => {
    setTestNumber('');
  };

  // fiut,ure technology for adding conection via code

  return (
    <FlexBox
      flexDirection="column"
      style={{
        gap: '10px',
      }}
    >
      <Text
        pt="10px"
        textAlign="center"
        fontWeight="bold"
        fontSize="large"
      >
        {t('lbl_your_liveroom_code')}
      </Text>
      <NumberInput
        size="large"
        isAutoFocus
        value={testNumber}
        onChange={(number: string) => setTestNumber(number)}
        codeLength={3}
      />
      <Button
        label={t('clear')}
        variant="secondary"
        onClick={onClear}
      />
      <Button
        label={t('connect')}
        onClick={() => false}
      />
    </FlexBox>
  );
};

export default LiveRoomConnectorPanel;
